import React from 'react';
import propTypes from 'prop-types';

import './index.css';
import * as navigator from '../../../native/navigator';


FooterSave.propTypes = {
  trip: propTypes.object.isRequired
};

export default function FooterSave(props) {
  let {trip} = props;

  return (
    <div className='footer-save'>
      <button onClick={function () {
        // 自动绑定，并打开预览页
        navigator.push('/m/v2/', {
          m: 'trip/copy',
          trip_id: trip.trip_id,
          source_app: 'tantutravel',
          version: '1.1'
        });
      }}>复制行程</button>
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/pages/trip/FooterSave/index.js